// YourComponent.jsx
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchQuestions } from './services/api'; // Import the fetchQuestions function

function YourComponent() {
  const dispatch = useDispatch();
  const { questions, status, error } = useSelector((state) => state.combined); // Ensure state key matches your Redux state structure

  useEffect(() => {
    // Dispatch the fetchQuestions action when the component mounts
    dispatch(fetchQuestions());
  }, [dispatch]); // Dispatch only once when the component mounts

  if (status === 'loading') {
    return <div>Loading...</div>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      {/* Render your questions here */}
      {questions.map((question) => (
        <div key={question.id}>
          <p>Question: {question.questionText}</p>
          <p>Answer: {question.answerText}</p>
          <p>Difficulty: {question.difficultyLevel}</p>
          <p>Category: {question.category}</p>
          <p>Course: {question.course}</p>
        </div>
      ))}
    </div>
  );
}

export default YourComponent;
